import { BadImplementationException, Module } from '@nu-art/ts-common';
import { StorageKey } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_AdvisorSession } from '../_entity/advisor-session/ModuleFE_AdvisorSession.js';
export class ModuleFE_EncounterStorage_Class extends Module {
    getStorageKey(key, persist = true) {
        const encounterId = ModuleFE_AdvisorSession.getCurrentEncounterId();
        if (!encounterId)
            throw new BadImplementationException(`Tried to access storage key '${key}' but encounterId was not set yet.`);
        return new StorageKey(`${encounterId}-${key}`, persist);
    }
}
export const ModuleFE_EncounterStorage = new ModuleFE_EncounterStorage_Class();
//# sourceMappingURL=ModuleFE_EncounterStorage.js.map